var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banner && _vm.banner.picture)?_c('div',{class:_vm.fullWidth ? 'w-100' : 'home-banner-holder'},[(_vm.banner)?_c('DynamicLinker',{staticClass:"d-flex",attrs:{"item":_vm.banner}},[_c('img',{staticClass:"w-100",attrs:{"loading":"lazy","src":_vm.banner.picture,"alt":_vm.banner.position_description}})]):_vm._e()],1):_c('Skeleton')
}
var staticRenderFns = []

export { render, staticRenderFns }